<template>
  <div class="img-verify-code-container">
    <el-input
      v-model="verifyCode"
      :prefix-icon="Picture"
      :maxlength="4"
      type="text"
      placeholder="验证码"
      @input="onInput"
    />
		
    <img id="verify-code-img" :src="imageSrc" />
    
    <span class="icon iconfont icon-shuaxin" @click="refreshVerifyCodeImage" />
  </div>
</template>
<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import * as easy from "@/components/easy"
import { Images } from "@/assets/Images"
import { ref } from "vue"
import { Picture } from "@element-plus/icons-vue"

import { getImageVerifyCode } from 'api/LoginAPI'
import { catchError } from '@/utils/utils'

const props = defineProps<{
  modelValue: { id: string, code: string }
}>()

const emit = defineEmits(['update:modelValue'])
const modelData = useVModel(props, 'modelValue', emit)

const verifyCode = ref('');

// 服务端返回的ID
let captchaId = '';

// 显示的图片
const imageSrc = ref();

async function refreshVerifyCodeImage() {
	imageSrc.value = Images.VERIFYCODE_REFRESH;
	
  const { response, error } = await catchError(getImageVerifyCode({captchaId}))
	if (error) {
    //if (specTimeOutCheck(error)) {
		imageSrc.value = Images.TRY_AGAIN
    //}

		modelData.value = { id: '', code: ''};
  } else {
    if (response!.code !== 0) {
			imageSrc.value = Images.TRY_AGAIN
			modelData.value = { id: '', code: ''};

			throw new easy.TipError(response!.message);
    }
		imageSrc.value = response!.data.imageData

		captchaId = response!.data.captchaId;

		modelData.value = { 
			id: captchaId, 
			code: verifyCode.value
		};
  }
}

const onInput = (value: string) => {
	modelData.value = {
		id: captchaId, 
		code: value
	};
}

onMounted(refreshVerifyCodeImage);

</script>
<style lang="scss" scoped>
.img-verify-code-container {
  position: relative;
  display: flex;
  align-items: center;
  .is-error {
    :deep(.el-input__inner) {
      border-color: #f56c6c;
    }
  }
  #verify-code-img {
    width: 80px;
    height: 35px;
    margin-right: 24px;
    margin-left: 16px;
  }
  // .img-code-icon {
  //   position: absolute;
  //   left: 11px;
  //   font-size: 14px;
  //   color: #c0c4cc;
  // }
  .icon-shuaxin {
    cursor: pointer;
    color: #8f98aa;
  }
  svg {
    cursor: pointer;
  }
}
</style>
